import VerifyOtp from './VerifyOtp';

export default VerifyOtp;

